import { render, staticRenderFns } from "./DiagonalArrowIcon.vue?vue&type=template&id=7190027c&scoped=true"
import script from "./DiagonalArrowIcon.vue?vue&type=script&lang=js"
export * from "./DiagonalArrowIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7190027c",
  null
  
)

export default component.exports